import { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debugLogPages } from '../../app/helpers/debugHelper';
import { startLoadingHomeContentItems } from '../../app/actions/homeContentActions';
import { HOME_CONTENT_TYPE_KEYS, pickHomeItems } from '../../app/helpers/homeContentHelper';

const EndUserSlider = () => {
    debugLogPages(':: EndUserSlider');
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const { dashboardBannerSliderEnabled } = useSelector((state) => state.configuration);
    const { items } = useSelector((state) => state.homeContent);

    const [index, setIndex] = useState(0);

    useEffect(() => {
        dispatch(startLoadingHomeContentItems());
    }, [dispatch]);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    const slides = pickHomeItems(items, HOME_CONTENT_TYPE_KEYS.BANNER, i18n.language).map((row) => ({
        id: row.id,
        title: row.title,
        text: row.text,
        url: row.image_url,
    }));

    return (
        <div style={{ width: '100%', overflow: 'hidden' }}>
            {dashboardBannerSliderEnabled === "true" && slides.length > 0 && (
                <Carousel activeIndex={index} onSelect={handleSelect}>
                    {slides.map((dat) => (
                            <Carousel.Item key={dat.id}>
                                <img
                                    className="d-block w-100"
                                    src={`${dat.url}`}
                                    alt={dat.title || t('homeContent.types.home.banner')}
                                    style={{ 
                                        minHeight: '400px', 
                                        maxHeight: '600px',
                                        width: '100%',
                                        objectFit: 'cover',
                                        objectPosition: 'center'
                                    }}
                                />
                                <Carousel.Caption 
                                    style={{ 
                                        background: 'rgba(0, 0, 0, 0.4)',
                                        width: '100%',
                                        left: '0',
                                        right: '0',
                                        bottom: '0',
                                        padding: '2rem 1rem',
                                        textAlign: 'center'
                                    }}
                                >
                                    <h3 className='carousel-text-title' style={{ fontSize: 'calc(1.3rem + 0.6vw)' }}>
                                        {dat.title}
                                    </h3>
                                    <p className='carousel-text-p' style={{ fontSize: 'calc(0.9rem + 0.3vw)' }}>
                                        {dat.text}
                                    </p>
                                </Carousel.Caption>
                            </Carousel.Item>
                        ))}
                </Carousel>
            )}
        </div>
    );
}

export default EndUserSlider;
